import React from "react";
import { Link } from "react-router-dom";

const Breadcrumb = ({ title, breadcrumbs }) => {
  return (
    <div className="rts-breadcrumb-area breadcrumb-bg bg_image">
      <style>
        {`
.rts-breadcrumb-area.breadcrumb-bg {
  height: 150px !important;
  min-height: 150px !important;
  padding: 0 !important;

  display: flex;
  align-items: center;

  background-size: cover !important;
  background-position: center center !important;

  overflow: hidden;
}
  /* Breadcrumb sol başlık */
.rts-breadcrumb-area .breadcrumb-1 .title {
  margin: 0 !important;
  padding: 0 !important;

  font-size: 34px !important;
  font-weight: 700 !important;
  line-height: 1.2 !important;
}

/* Sağ breadcrumb yazıları */
.rts-breadcrumb-area .bread-tag .breadcrumb-link,
.rts-breadcrumb-area .bread-tag .active {
  font-size: 15px !important;
  line-height: 1.4 !important;
}

.rts-breadcrumb-area .bread-tag .breadcrumb-separator {
  font-size: 14px !important;
}
          .bread-tag {
            display: flex;
            align-items: center;
            justify-content: flex-end;
            flex-wrap: wrap;

            gap: 0;

            width: fit-content;
            max-width: 100%;

            margin-left: auto;

            padding: 14px 22px;

            background: #ffffff;
            border-radius: 30px;
          }

          .bread-tag .breadcrumb-item-custom {
            display: inline-flex;
            align-items: center;
          }

          .bread-tag .breadcrumb-link,
          .bread-tag .active {
            display: inline-block;

            font-size: 15px;
            line-height: 1.4;

            text-decoration: none;
          }

          .bread-tag .breadcrumb-link {
            color: #e20614;
            font-weight: 700;
          }

          .bread-tag .breadcrumb-link:hover {
            color: #b80410;
          }

          .bread-tag .active {
            color: #e20614;
            font-weight: 400;
          }

          .bread-tag .breadcrumb-separator {
            display: inline-block;

            margin: 0 10px;

            color: #e20614;

            font-size: 14px;
            font-weight: 400;
            line-height: 1;
          }

          @media (max-width: 767.98px) {
            .bread-tag {
              justify-content: flex-start;

              width: 100%;
              margin: 18px 0 0;

              padding: 12px 16px;

              border-radius: 16px;
            }

            .bread-tag .breadcrumb-link,
            .bread-tag .active {
              font-size: 13px;
            }

            .bread-tag .breadcrumb-separator {
              margin: 0 7px;
            }
          }
            @media (max-width: 767.98px) {
  .rts-breadcrumb-area.breadcrumb-bg {
    height: auto !important;
    min-height: 140px !important;
    padding: 18px 0 !important;
  }

  .rts-breadcrumb-area .breadcrumb-1 .title {
    font-size: 28px !important;
    line-height: 1.2;
    margin: 0 0 12px !important;
    text-align: center;
  }

  .bread-tag {
    justify-content: center;

    width: fit-content !important;
    max-width: calc(100% - 20px);

    margin: 6px auto 0 !important;
    padding: 7px 12px !important;

    border-radius: 24px;
  }

  .bread-tag .breadcrumb-link,
  .bread-tag .active {
    font-size: 11px !important;
    line-height: 1.3;
  }

  .bread-tag .breadcrumb-separator {
    margin: 0 5px !important;
    font-size: 11px;
  }
}
        `}
      </style>

      <div className="container">
        <div className="row align-items-center">
          <div className="col-xl-6 col-lg-6 col-md-6 col-sm-12 col-12 breadcrumb-1">
            <h1 className="title">{title}</h1>
          </div>

          <div className="col-xl-6 col-lg-6 col-md-6 col-sm-12 col-12">
            <div className="bread-tag">
              {breadcrumbs.map((breadcrumb, index) => (
                <span key={index} className="breadcrumb-item-custom">
                  {breadcrumb.link ? (
                    <Link to={breadcrumb.link} className="breadcrumb-link">
                      {breadcrumb.label}
                    </Link>
                  ) : (
                    <span className="active">{breadcrumb.label}</span>
                  )}

                  {index < breadcrumbs.length - 1 && (
                    <span className="breadcrumb-separator" aria-hidden="true">
                      /
                    </span>
                  )}
                </span>
              ))}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Breadcrumb;
